/* ============================================================================
   ATHLO+ — Directory (reusable filterable listing)
   ----------------------------------------------------------------------------
   Powers the Venues, Races & Events and Ask-an-Expert directories from a single
   engine. Each dataset entry shares one shape:
     { id, name, primary, secondary, area, detail, fee, web, ig, blurb }
   The section names the dataset global (data-var) and the filter labels.
   Primary = chip filter (no "All" — pick one; type to search across all).
   Secondary = optional dropdown ("All …"). Mounts into [data-directory].
   ========================================================================== */
(function () {
  'use strict';

  function el(t, c, h) { var n = document.createElement(t); if (c) n.className = c; if (h != null) n.innerHTML = h; return n; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function track(name, detail) {
    try { window.dispatchEvent(new CustomEvent('hub:directory', { detail: Object.assign({ event: name }, detail || {}) })); } catch (e) {}
    if (typeof window.gtag === 'function') window.gtag('event', name, detail || {});
  }

  function Dir(root) {
    // Prefer admin-editable metaobjects (window.<VAR>_MO, injected by the section
    // when the matching metaobjects exist — run migrate-hub-metaobjects.js); fall
    // back to the JS seed. Editable via Shopify admin → Content → Metaobjects.
    var varName = root.getAttribute('data-var');
    var mo = window[varName + '_MO'];
    var DATA = ((mo && mo.length) ? mo : (window[varName] || [])).slice();
    if (!DATA.length) return;
    var SEC_LABEL = root.getAttribute('data-secondary-label') || 'Area';
    var PLACEHOLDER = root.getAttribute('data-placeholder') || 'Search…';

    var PRIMARY = [];
    DATA.forEach(function (d) { if (d.primary && PRIMARY.indexOf(d.primary) < 0) PRIMARY.push(d.primary); });
    var SECOND = [];
    DATA.forEach(function (d) { if (d.secondary && SECOND.indexOf(d.secondary) < 0) SECOND.push(d.secondary); });

    var state = { q: '', primary: PRIMARY[0] || '', secondary: '' };

    function filtered() {
      var q = state.q.trim().toLowerCase();
      if (q) {
        return DATA.filter(function (d) {
          var hay = (d.name + ' ' + d.primary + ' ' + d.secondary + ' ' + (d.area || '') + ' ' + (d.detail || '') + ' ' + (d.blurb || '')).toLowerCase();
          return hay.indexOf(q) > -1;
        });
      }
      return DATA.filter(function (d) {
        if (state.primary && d.primary !== state.primary) return false;
        if (state.secondary && d.secondary !== state.secondary) return false;
        return true;
      });
    }

    function card(d) {
      var links = '';
      if (d.web) links += '<a class="dir__link" href="' + esc(d.web) + '" target="_blank" rel="noopener" data-d="web"><span aria-hidden="true">↗</span> Visit</a>';
      if (d.ig) links += '<a class="dir__link" href="https://instagram.com/' + esc(d.ig) + '" target="_blank" rel="noopener" data-d="ig"><span aria-hidden="true">◎</span> @' + esc(d.ig) + '</a>';
      if (d.maps || d.area) links += '<a class="dir__link" href="https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(d.maps || ((d.name || '') + ' ' + (d.area || '') + ' Singapore')) + '" target="_blank" rel="noopener" data-d="map"><span aria-hidden="true">⌖</span> Map</a>';
      var meta = '';
      if (d.area) meta += '<div><dt aria-label="Location">⌖</dt><dd>' + esc(d.area) + (d.secondary ? ' <span class="dir__sec">· ' + esc(d.secondary) + '</span>' : '') + '</dd></div>';
      if (d.detail) meta += '<div><dt aria-label="Detail">›</dt><dd>' + esc(d.detail) + '</dd></div>';
      if (d.fee) meta += '<div><dt aria-label="Cost">$</dt><dd>' + esc(d.fee) + '</dd></div>';
      var node = el('article', 'dir');
      node.innerHTML =
        '<div class="dir__top"><span class="dir__tag">' + esc(d.primary) + '</span>' +
          (d.secondary ? '<span class="dir__pill">' + esc(d.secondary) + '</span>' : '') + '</div>' +
        '<h3 class="dir__name">' + esc(d.name) + '</h3>' +
        (d.blurb ? '<p class="dir__blurb">' + esc(d.blurb) + '</p>' : '') +
        (meta ? '<dl class="dir__meta">' + meta + '</dl>' : '') +
        (links ? '<div class="dir__links">' + links + '</div>' : '');
      node.querySelectorAll('[data-d]').forEach(function (a) {
        a.addEventListener('click', function () { track('directory_visit', { id: d.id, channel: a.getAttribute('data-d') }); });
      });
      if (window.HubSave) {
        var tmap = { HUB_VENUES: 'Venue', HUB_RACES: 'Race', HUB_EXPERTS: 'Expert' };
        node.appendChild(window.HubSave.button({
          id: (varName || 'dir').toLowerCase() + ':' + d.id, type: tmap[varName] || 'Listing', name: d.name,
          sub: [d.primary, d.area || d.secondary].filter(Boolean).join(' · '),
          url: d.web || ('https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(d.maps || ((d.name || '') + ' ' + (d.area || '') + ' Singapore')))
        }));
      }
      return node;
    }

    function render() {
      root.innerHTML = '';
      var controls = el('div', 'dir__controls');

      var search = el('div', 'dir__search');
      var input = el('input', 'dir__input');
      input.type = 'search'; input.value = state.q; input.placeholder = PLACEHOLDER; input.setAttribute('aria-label', 'Search');
      input.addEventListener('input', function () { state.q = input.value; paint(); });
      search.appendChild(input); controls.appendChild(search);

      var chips = el('div', 'dir__chips');
      PRIMARY.forEach(function (p) {
        var n = DATA.filter(function (d) { return d.primary === p; }).length;
        var chip = el('button', 'dir__chip' + (state.primary === p ? ' is-on' : ''), esc(p) + ' <span class="dir__chip-n">' + n + '</span>');
        chip.type = 'button';
        chip.addEventListener('click', function () { state.primary = p; render(); track('directory_filter', { primary: p }); });
        chips.appendChild(chip);
      });
      controls.appendChild(chips);

      if (SECOND.length) {
        var selects = el('div', 'dir__selects');
        var sec = el('select', 'dir__select');
        sec.setAttribute('aria-label', SEC_LABEL);
        sec.innerHTML = '<option value="">All ' + esc(SEC_LABEL.toLowerCase()) + '</option>' + SECOND.map(function (s) { return '<option value="' + esc(s) + '"' + (state.secondary === s ? ' selected' : '') + '>' + esc(s) + '</option>'; }).join('');
        sec.addEventListener('change', function () { state.secondary = sec.value; render(); });
        selects.appendChild(sec);
        if (state.q || state.secondary) {
          var reset = el('button', 'dir__reset', 'Clear'); reset.type = 'button';
          reset.addEventListener('click', function () { state.q = ''; state.secondary = ''; render(); });
          selects.appendChild(reset);
        }
        controls.appendChild(selects);
      }
      root.appendChild(controls);

      var results = el('div', 'dir__results'); results.setAttribute('data-d-results', '');
      root.appendChild(results);
      paintInto(results);
    }

    function paintInto(results) {
      var list = filtered();
      results.innerHTML = '';
      var count = el('p', 'dir__count', '<strong>' + list.length + '</strong> ' + (list.length === 1 ? 'result' : 'results') + (state.q ? ' for “' + esc(state.q) + '”' : (state.primary ? ' · ' + esc(state.primary) : '')));
      results.appendChild(count);
      if (!list.length) { results.appendChild(el('div', 'dir__empty', "Nothing matches yet. Try another filter — or tell us what's missing and we'll add it.")); return; }
      var grid = el('div', 'dir__grid');
      list.forEach(function (d) { grid.appendChild(card(d)); });
      results.appendChild(grid);
    }
    function paint() { var r = root.querySelector('[data-d-results]'); if (r) paintInto(r); else render(); }

    render();
  }

  function init() {
    document.querySelectorAll('[data-directory]').forEach(function (root) {
      if (root.__directory) return; root.__directory = true; new Dir(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
